import { render, staticRenderFns } from "./OrderDialog.vue?vue&type=template&id=bdbc5914&scoped=true"
import script from "./OrderDialog.vue?vue&type=script&lang=js"
export * from "./OrderDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderDialog.vue?vue&type=style&index=0&id=bdbc5914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbc5914",
  null
  
)

export default component.exports